<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchHomeGatewayForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchHomeGatewayForm.search" placeholder="关键字搜索" @keyup.enter.native="searchHomeGateway" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="searchHomeGateway">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="deliveryAuthorization">交付授权</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="homeGatewayList"
                  stripe
                  style="max-width: 100%">
                  <el-table-column
                    prop="homeid"
                    label="住宅ID"
                    show-overflow-tooltip
                    min-width="200"/>
                  <el-table-column
                    prop="homename"
                    label="住宅名称"
                    show-overflow-tooltip
                    min-width="200"/>
                  <el-table-column
                    prop="gatewayid"
                    label="网关id"
                    show-overflow-tooltip
                    min-width="200"/>
                  <el-table-column
                    prop="username"
                    label="关联手机号"
                    align="center"
                    show-overflow-tooltip
                    min-width="120"/>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="绑定用户"
                    show-overflow-tooltip
                    width="120">
                    <template slot-scope="scope">
                      <span v-if="scope.row.userid === 0" style="color:#F56C6C">未绑定</span>
                      <span v-if="scope.row.userid !== 0">{{ scope.row.nickname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    width="450"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-dropdown split-button icon="el-icon-edit" size="mini" style="margin-right: 10px">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="color: dodgerblue" @click.native="editHomeName(scope.row)"><i class="el-icon-edit"></i> 修改住宅</el-dropdown-item>
                          <el-dropdown-item style="color:#F56C6C" @click.native="delGatewayHome(scope.row)"><i class="el-icon-delete"></i> 删除住宅</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button icon="el-icon-document" size="mini" @click="getDeviceList(scope.row)">查看设备</el-button>
                      <el-button icon="el-icon-connection" size="mini" @click="bindUser(scope.row)">绑定用户</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="修改住宅名称"
      :visible.sync="editDialogVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form ref="homenameRef" size="small" label-width="90px" :model="homeForm" :rules="homeRules">
            <el-form-item label="住宅名称" prop="homename">
              <el-input v-model="homeForm.homename" placeholder="请输入住宅名称" maxlength="100" show-word-limit>
              </el-input>
            </el-form-item>
            <el-form-item style="text-align: right;">
              <el-button type="primary" :loading="editLoading" @click="submitGateway">提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="用户列表"
      :visible.sync="userDialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form :inline="true" size="small" :model="searchUserForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchUserForm.search" placeholder="关键字搜索" @keyup.enter.native="searchUser" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="searchUser">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="userLoading" :span="24">
                <el-table
                  :data="userList"
                  stripe
                  style="width: 100%;margin-bottom: 20px">
                  <el-table-column
                    prop="nickname"
                    label="用户昵称"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="电话"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                      <div>
                        <i class="el-icon-phone-outline"/> {{ scope.row.username }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="tel"
                    label="联系电话"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                      <div v-if="scope.row.tel===''">
                        未填写
                      </div>
                      <div v-else>
                        <i class="el-icon-phone"/> {{ scope.row.tel }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="wchat"
                    align="center"
                    label="微信"
                    :show-overflow-tooltip="true"
                    width="150">
                    <template slot-scope="scope">
                      <div v-if="scope.row.wchat===''">
                        未填写
                      </div>
                      <div v-else>
                        <svg-icon icon-class="wechat" style="color:#606266;width: 13px;" />
                        {{ scope.row.dWchat }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="email"
                    label="email"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="150">
                    <template slot-scope="scope">
                      <div v-if="scope.row.email===''">
                        未填写
                      </div>
                      <div v-else>
                        <i class="el-icon-message"/> {{ scope.row.email }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="地址"
                    width="150">
                    <template slot-scope="scope">
                      <div v-if="scope.row.province===''&&scope.row.city===''&&scope.row.county===''">未填写</div>
                      <div v-if="scope.row.province!==''&&scope.row.city===''&&scope.row.county===''">
                        <i class="el-icon-location"/> {{ scope.row.province }}
                      </div>
                      <div v-if="scope.row.province!==''&&scope.row.city!==''&&scope.row.county===''">
                        <i class="el-icon-location"/> {{ scope.row.province }}/{{ scope.row.city }}
                      </div>
                      <div v-if="scope.row.province!==''&&scope.row.city!==''&&scope.row.county!==''">
                        <i class="el-icon-location"/> {{ scope.row.province }}/{{ scope.row.city }}/{{ scope.row.county }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="性别"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.sex==='男'" size="small">♂ 男</el-tag>
                      <el-tag v-if="scope.row.sex==='女'" type="danger" size="small">♀ 女</el-tag>
                      <el-tag v-if="scope.row.sex===''" size="small" type="info">无</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-connection" size="mini" @click="bind(scope.row)">绑定</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="userTotal>0"
                  background
                  :current-page="userCurrentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="userPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="userTotal"
                  @size-change="userHandleSizeChange"
                  @current-change="userHandleCurrentChange">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="设备列表"
      :visible.sync="deviceListDialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <div class="card-content">
            <el-row>
              <el-col v-loading="deviceListLoading" :span="24">
                <el-table
                  :data="deviceList"
                  stripe
                  style="width: 100%;margin-bottom: 20px">
                  <el-table-column
                    prop="sid"
                    label="功能ID"
                    show-overflow-tooltip
                    width="250"/>
                  <el-table-column
                    prop="spk"
                    label="功能类型"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    prop="name"
                    label="设备名称"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    prop="deviceid"
                    label="设备ID"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    prop="homeid"
                    label="住宅ID"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    prop="gatewayid"
                    label="网关ID"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    align="center"
                    label="是否在线"
                    show-overflow-tooltip
                    fixed="right"
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.online === 1" style="color: #67C23A"><i class="el-icon-success"/></span>
                      <span v-if="scope.row.online === 0" style="color: #e01222"><i class="el-icon-error"/></span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="未授权住宅列表"
      :visible.sync="unauthorizedHomeDialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form :inline="true" size="small" :model="searchUnauthorizedHomeListForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchUnauthorizedHomeListForm.search" placeholder="关键字搜索" @keyup.enter.native="searchUnauthorizedHomeList" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="searchUnauthorizedHomeList">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="unauthorizedHomeLoading" :span="24">
                <el-table
                  :data="unauthorizedHomeList"
                  stripe
                  style="width: 100%;margin-bottom: 20px">
                  <el-table-column
                    prop="homeid"
                    label="住宅ID"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    prop="name"
                    label="住宅名称"
                    show-overflow-tooltip
                    width="200"/>
                  <el-table-column
                    label="是否绑定网关"
                    show-overflow-tooltip
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isbindgateway === 0">未绑定</span>
                      <span v-if="scope.row.isbindgateway === 1">已绑定</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="住宅类型"
                    show-overflow-tooltip
                    align="center"
                    width="100"/>
                  <el-table-column
                    label="交付状态"
                    align="center"
                    show-overflow-tooltip
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.deliver === 'UNDELIVERED'">未交付</span>
                      <span v-if="scope.row.deliver !== 'UNDELIVERED'">已交付</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="100"
                    align="center"
                    fixed="right">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="delivery(scope.row)">交付</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="交付授权"
      :visible.sync="deliveryDialogVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form ref="deliveryRef" size="small" label-width="90px" :model="deliveryForm" :rules="rules">
            <el-form-item label="用户电话" prop="username">
              <el-input v-model="deliveryForm.username" placeholder="请输入用户电话" onkeyup="value=value.replace(/[^\d.]/g,'')" show-word-limit>
              </el-input>
            </el-form-item>
            <el-form-item style="text-align: right;">
              <el-button type="primary" :loading="btnLoading" @click="submitDelivery">交付</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getHomeGateWayList,
  getHDLUnauthorizedHomeList,
  deliveryUser,
  updateHomeName,
  getDeviceList,
  getClientUserList, gatewayBindUser, delGatewayHome
} from '@/api/zzjf'

export default {
  name: 'Zzjf',
  data() {
    return {
      searchHomeGatewayForm: {
        search: ''
      },
      searchUnauthorizedHomeListForm: {
        search: ''
      },
      searchUserForm: {
        search: ''
      },
      homeForm: {
        id: '',
        homename: ''
      },
      deliveryForm: {
        homeid: '',
        homename: '',
        username: ''
      },
      hgid: null,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      userCurrentPage: 1,
      userPageSize: 20,
      userTotal: 0,
      homeGatewayList: [],
      unauthorizedHomeList: [],
      clientUserList: [],
      deviceList: [],
      userList: [],
      loading: false,
      unauthorizedHomeLoading: false,
      btnLoading: false,
      editLoading: false,
      userLoading: false,
      deviceListLoading: false,
      editDialogVisible: false,
      userDialogVisible: false,
      deviceListDialogVisible: false,
      unauthorizedHomeDialogVisible: false,
      deliveryDialogVisible: false,
      rules: {
        username: [{ required: true, message: '请输入电话号码', trigger: 'blur' }]
      },
      homeRules: {
        homename: [{ required: true, message: '请输入住宅名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getHomeGatewayList()
  },
  methods: {
    searchHomeGateway() {
      this.currentPage = 1
      this.getHomeGatewayList()
    },
    searchUnauthorizedHomeList() {
      this.getHDLUnauthorizedHomeList()
    },
    searchUser() {
      this.userCurrentPage = 1
      this.getUserList()
    },
    bindUser(row) {
      this.hgid = row.hgid
      this.userDialogVisible = true
      this.getUserList()
    },
    getUserList() {
      this.userLoading = true
      const data = {
        search: this.searchUserForm.search,
        page: this.userCurrentPage,
        limit: this.userPageSize
      }
      getClientUserList(data).then(response => {
        this.userList = response.data
        this.userTotal = response.total
        this.userLoading = false
      }).catch(() => {
        this.userLoading = false
      })
    },
    bind(row) {
      const data = {
        hgid: this.hgid,
        userid: row.userid
      }
      gatewayBindUser(data).then(response => {
        this.$message({
          message: response.msg,
          type: 'success'
        })
        this.userDialogVisible = false
        this.getHomeGatewayList()
      }).catch(() => {})
    },
    getHomeGatewayList() {
      this.loading = true
      const data = {
        search: this.searchHomeGatewayForm.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getHomeGateWayList(data).then(response => {
        this.homeGatewayList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 交付授权
    deliveryAuthorization() {
      this.getHDLUnauthorizedHomeList()
      this.unauthorizedHomeDialogVisible = true
    },
    getHDLUnauthorizedHomeList() {
      this.unauthorizedHomeLoading = true
      const data = {
        search: this.searchUnauthorizedHomeListForm.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getHDLUnauthorizedHomeList(data).then(response => {
        this.unauthorizedHomeList = response.data
        this.unauthorizedHomeLoading = false
      }).catch(() => {
        this.unauthorizedHomeLoading = false
      })
    },
    delivery(row) {
      this.deliveryForm.username = ''
      this.deliveryForm.homeid = row.homeid
      this.deliveryForm.homename = row.name
      this.deliveryDialogVisible = true
    },
    submitDelivery() {
      if (!this.btnLoading) {
        this.$refs['deliveryRef'].validate((valid) => {
          if (valid) {
            const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg_tel.test(this.deliveryForm.username)) {
              this.$message.error('请输入正确的手机号码')
              this.deliveryForm.username = ''
            } else {
              const data = {
                homeid: this.deliveryForm.homeid,
                homename: this.deliveryForm.homename,
                username: this.deliveryForm.username
              }
              this.btnLoading = true
              deliveryUser(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.btnLoading = false
                this.deliveryDialogVisible = false
                this.unauthorizedHomeDialogVisible = false
                this.getHomeGatewayList()
              }).catch(() => {
                this.btnLoading = false
              })
            }
          } else {
            return false
          }
        })
      }
    },
    editHomeName(gateway) {
      this.homeForm.hgid = gateway.hgid
      this.homeForm.homeid = gateway.homeid
      this.homeForm.homename = gateway.homename
      this.homeForm.gatewayid = gateway.gatewayid
      this.homeForm.userid = gateway.userid
      this.editDialogVisible = true
    },
    submitGateway() {
      if (!this.editLoading) {
        this.$refs['homenameRef'].validate((valid) => {
          if (valid) {
            const data = {
              hgid: this.homeForm.hgid,
              homeid: this.homeForm.homeid,
              homename: this.homeForm.homename,
              gatewayid: this.homeForm.gatewayid,
              userid: this.homeForm.userid
            }
            this.editLoading = true
            updateHomeName(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editLoading = false
              this.editDialogVisible = false
              this.getHomeGatewayList()
            }).catch(() => {
              this.editLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    delGatewayHome(row) {
      this.$confirm('您确定要删除此住宅吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delGatewayHome({ hgid: row.hgid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getHomeGatewayList()
        })
      }).catch(() => {})
    },
    getDeviceList(gateway) {
      this.deviceListDialogVisible = true
      this.deviceListLoading = true
      const data = {
        homeid: gateway.homeid,
        gatewayid: gateway.gatewayid
      }
      getDeviceList(data).then(response => {
        this.deviceList = response.data
        this.deviceListLoading = false
      }).catch(() => {
        this.deviceListLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    userHandleSizeChange(val) {
      this.userPageSize = val
      this.getUserList()
    },
    userHandleCurrentChange(val) {
      this.userCurrentPage = val
      this.getUserList()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
